import { faker } from '@faker-js/faker';
import { min, sample } from 'lodash';

// ----------------------------------------------------------------------
const SLOTS = [
  '10:00 - 12:00',
  '11:30 - 13:40',
  '14:00 - 15:20',
  '15:30 - 16:40',
  '17:00 - 18:20',
  '18:30 - 19:40',
  '20:00 - 21:20',
  '21:30 - 22:40',
  '23:00 - 00:20',
  '00:30 - 01:40',
  '02:00 - 03:20',
  '03:30 - 04:40',
  '05:00 - 06:20',
  '12:00 - 14:00',
  '14:00 - 16:00',
  '16:00 - 18:00',
  '18:00 - 20:00',
  '20:00 - 22:00',
  '22:00 - 24:00',
  '00:00 - 02:00',
  '02:00 - 04:00',
  '04:00 - 06:00',
  '06:00 - 08:00',
  '08:00 - 10:00',
];
const current = [
  {
    id: 7,
    name: 'downtown parking',
    capacity: 10,
    address: 'Pune',
    latitude: 10,
    cityId: 1,
    stateId: 10,
    zipCode: '13001',
    phoneNumber: '8975797254',
    parkingCategory: 'Luxry',
    description: 'downtown parking',
    hasSecurity: true,
    hasValet: true,
    hasChargingStation: true,
    hasServicing: true,
    hasWash: true,
    hasADA: true,
    termAndCondition: 'accepted',
    parkingRefundType: true,
    parkingRate: 10,
    currentStatus: 'active',
    openAt: '07:00 am',
    closeAt: '09:00 pm',
    discount: 10,
    longitude: 10,
  },
  {
    id: 8,
    name: 'zenanli parking',
    capacity: 10,
    address: 'Pune',
    latitude: 10,
    cityId: 1,
    stateId: 10,
    zipCode: '13001',
    phoneNumber: '8975797254',
    parkingCategory: 'PCTO',
    description: 'zenanli parking\n',
    hasSecurity: true,
    hasValet: true,
    hasChargingStation: true,
    hasServicing: true,
    hasWash: true,
    hasADA: true,
    termAndCondition: 'accepted',
    parkingRefundType: true,
    parkingRate: 10,
    currentStatus: 'active',
    openAt: '07:00 am',
    closeAt: '09:00 pm',
    discount: 40,
    longitude: 10,
  },
  {
    id: 9,
    name: 'burgsville parking',
    capacity: 10,
    address: 'Pune',
    latitude: 10,
    cityId: 1,
    stateId: 10,
    zipCode: '13001',
    phoneNumber: '8975797254',
    parkingCategory: 'PCTL',
    description: 'burgsville parking',
    hasSecurity: true,
    hasValet: true,
    hasChargingStation: true,
    hasServicing: true,
    hasWash: true,
    hasADA: true,
    termAndCondition: 'accepted',
    parkingRefundType: true,
    parkingRate: 10,
    currentStatus: 'active',
    openAt: '07:00 am',
    closeAt: '09:00 pm',
    discount: 40,
    longitude: 10,
  },
  {
    id: 10,
    name: 'North Beach Parking',
    capacity: 30,
    address: 'San Fransisco, CA 94103, United States',
    latitude: 0.532,
    cityId: 1,
    stateId: 10,
    zipCode: '13001',
    phoneNumber: 'string',
    parkingCategory: 'PCTO',
    description: 'North beach parking',
    hasSecurity: true,
    hasValet: true,
    hasChargingStation: true,
    hasServicing: true,
    hasWash: true,
    hasADA: true,
    termAndCondition: 'accepted',
    parkingRefundType: true,
    parkingRate: 12,
    currentStatus: 'active',
    openAt: '07:00 am',
    closeAt: '09:00 pm',
    discount: 20,
    longitude: 0.332,
  },
  {
    id: 15,
    name: 'Spotfinder Parking',
    capacity: 25,
    address: 'Parking location',
    latitude: 0.532,
    cityId: 2,
    stateId: 11,
    zipCode: '13002',
    phoneNumber: '987856521',
    parkingCategory: 'PCTO',
    description: 'A long description',
    hasSecurity: true,
    hasValet: true,
    hasChargingStation: true,
    hasServicing: true,
    hasWash: true,
    hasADA: true,
    termAndCondition: 'accepted',
    parkingRefundType: true,
    parkingRate: 15,
    currentStatus: 'pending',
    openAt: 'Mon Jan 01 2018 08:30:00 GMT+0530 (India Standard Time)',
    closeAt: 'Mon Jan 01 2018 00:30:00 GMT+0530 (India Standard Time)',
    discount: 20,
    longitude: 0.332,
  },
];

const dates = [
  {
    id: 1,
    date: '19-11-2021',
  },
  {
    id: 2,
    date: '20-01-2022',
  },
  {
    id: 3,
    date: '24-07-2021',
  },
  {
    id: 4,
    date: '02-09-2021',
  },
  {
    id: 5,
    date: '09-01-2022',
  },
  {
    id: 6,
    date: '01-01-2022',
  },
  {
    id: 7,
    date: '06-06-2022',
  },
  {
    id: 8,
    date: '14-05-2022',
  },
  {
    id: 9,
    date: '25-07-2021',
  },
  {
    id: 10,
    date: '28-11-2021',
  },
];

const past = [...Array(24)].map((_, index) => ({
  id: faker.datatype.uuid(),
  avatarUrl: `/static/mock-images/avatars/avatar_${index + 1}.jpg`,
  name: faker.name.findName(),
  company: faker.company.companyName(),
  isVerified: faker.datatype.boolean(),
  status: sample(['active', 'banned']),
  role: sample([
    'Leader',
    'Hr Manager',
    'UI Designer',
    'UX Designer',
    'UI/UX Designer',
    'Project Manager',
    'Backend Developer',
    'Full Stack Designer',
    'Front End Developer',
    'Full Stack Developer',
  ]),
}));
const rescheduled = [...Array(24)].map((_, index) => ({
  id: faker.datatype.uuid(),
  avatarUrl: `/static/mock-images/avatars/avatar_${index + 1}.jpg`,
  name: faker.name.findName(),
  company: faker.company.companyName(),
  isVerified: faker.datatype.boolean(),
  status: sample(['active', 'banned']),
  role: sample([
    'Leader',
    'Hr Manager',
    'UI Designer',
    'UX Designer',
    'UI/UX Designer',
    'Project Manager',
    'Backend Developer',
    'Full Stack Designer',
    'Front End Developer',
    'Full Stack Developer',
  ]),
}));
const cancellations = [...Array(24)].map((_, index) => ({
  id: faker.datatype.uuid(),
  name: faker.name.findName(),
  company: faker.company.companyName(),
  isVerified: faker.datatype.boolean(),
  status: sample(['PAID', 'UNPAID']),
  status2: sample(['APPROVE', 'CANCEL']),
  role: faker.datatype.number({ min: 4, max: 99, precision: 0.01 }),
}));
const bookings = [...Array(24)].map((_, index) => ({
  id: faker.datatype.uuid(),
  name: faker.name.findName(),
  company: faker.company.companyName(),
  isVerified: faker.datatype.boolean(),
  status: sample(['PAID', 'UNPAID']),
  status2: sample(['APPROVE', 'CANCEL']),
  role: faker.datatype.number({ min: 4, max: 99, precision: 0.01 }),
}));

const offers = [...Array(5)].map((_, index) => ({
  id: faker.datatype.uuid(),
  name: faker.name.findName(),
  validIn: faker.address.cityName(),
  percentage: faker.random.numeric({ min: 10, max: 99, precision: 0.01 }),
  validTill: faker.date.future(),
  promo: faker.random.alphaNumeric(5),
  status: sample(['active', 'expired']),
}));

const cities = [...Array(10)].map((_, index) => ({
  id: index + 1,
  name: faker.address.cityName(),
  cityId: faker.datatype.uuid(),
  country: faker.address.country(),
  countryId: faker.datatype.uuid(),
  state: faker.address.state(),
  stateId: faker.datatype.uuid(),
  avatarUrl: `/static/mock-images/avatars/avatar_${index + 1}.jpg`,
}));

const Parking = [...Array(10)].map((_, index) => ({
  id: index + 1,
  parkingType: sample(['Regular', 'Luxury', 'Exclusive', 'Flexi']),
  percentage: faker.random.numeric({ min: 10, max: 99, precision: 0.01 }),
  avatarUrl: `/static/mock-images/avatars/avatar_${index + 1}.jpg`,
}));
const wallet = [...Array(5)].map((_, index) => ({
  id: index + 1,
  name: faker.name.findName(),
  userId: faker.random.numeric(5),
  date: faker.date.future(),
  amount: faker.random.numeric({ min: 100, max: 1000, precision: 0.01 }),
  opening: faker.random.numeric({ min: 50, max: 999, precision: 0.01 }),
  closing: faker.random.numeric({ min: 50, max: 999, precision: 0.01 }),
  status: faker.datatype.boolean(),
}));

const commission = [...Array(5)].map((_, index) => ({
  id: index + 1,
  vendorName: faker.name.findName(),
  userId: faker.random.numeric(5),
  parkingName: faker.address.streetName(),
  contact: faker.phone.phoneNumberFormat(),
  tierType: faker.random.alphaNumeric(2),
  commissionType: faker.random.numeric({ min: 100, max: 1000, precision: 0.01 }),
}));

const vendorFlagging = [...Array(5)].map((_, index) => ({
  id: index + 1,
  parkingSpaceName: faker.address.streetAddress(),
  active: faker.datatype.boolean(),
  suspend: faker.datatype.boolean(),
  retention: faker.datatype.boolean(),
  dead: faker.datatype.boolean(),
  closing: faker.datatype.boolean(),
  edit: faker.datatype.boolean(),
  deleted: faker.datatype.boolean(),
}));
const country = [...Array(10)].map((_, index) => ({
  id: index + 1,
  name: faker.address.cityName(),
  cityId: faker.datatype.uuid(),
  country: faker.address.country(),
  countryId: faker.datatype.uuid(),
  state: faker.address.state(),
  stateId: faker.datatype.uuid(),
}));

export {
  current,
  past,
  rescheduled,
  cancellations,
  bookings,
  offers,
  cities,
  wallet,
  dates,
  commission,
  vendorFlagging,
  country,
  Parking,
};
